import React, { useState } from 'react'

import axios from 'axios';

import { IPassportDetail } from '../../../interfaces/services';

import { TextInput, CalenderInput } from '../../reusables/FormElements';

import DocumentMetadata from '../student/immigration/DocumentMetadata';
import ViewDocument from '../student/immigration/ViewDocument';

interface IPassportFormProps {
    studentId: number;
    data: IPassportDetail;
}

const PassportForm = (props: IPassportFormProps) => {
    const { studentId, data } = props;

    const { passport_number, issued, expire, nationality, document } = data;

    const [showDocument, setShowDocument] = useState(false);

    const onPreviewFile = () => {
        setShowDocument(true);
    }

    const onMinimizePreview = () => {
        setShowDocument(false);
    }

    const onDownloadFile = async (url: string) => {
        try {
            const response = await axios.get(url, { responseType: 'blob' });

            url = URL.createObjectURL(new Blob([response.data]));
            const link = window.document.createElement('a');
            link.href = url;
            link.download = document?.original || document?.display || 'document';
            window.document.body.appendChild(link);
            link.click();
            window.document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    return (
        <div className='immersion__details_form_inputs__container__deletable_forms__with__preview'>
            <div className='immersion__details_form_inputs__container__deletable_forms'>
                {document &&
                    <DocumentMetadata
                        fileName={document.original || document.display}
                        onPreviewFile={onPreviewFile}
                    />
                }
                <div className="immersion__details_form_inputs">
                    <TextInput
                        name="passportNumber"
                        type="text"
                        label="Passport Number"
                        max_length={50}
                        required={true}
                        pattern_mask="doc_number"
                        placeholder=""
                        value={passport_number}
                        onChange={(value: string) => { }}
                        errorMsg={''}
                        read_only={true}
                    />
                    <TextInput
                        name="nationality"
                        type="text"
                        label="Passport country"
                        placeholder=""
                        value={nationality ?? ''}
                        onChange={(value: string) => { }}
                        errorMsg={''}
                        read_only={true}
                    />
                    <CalenderInput
                        name="issueDate"
                        label="Issue Date"
                        errorMsg={''}
                        placeholder=""
                        format="mm/dd/yyyy"
                        onChange={(value: string) => { }}
                        value={issued ?? ''}
                        read_only={true}
                    />
                    <CalenderInput
                        name="expiryDate"
                        label="Expiry Date"
                        errorMsg={''}
                        placeholder=""
                        format="mm/dd/yyyy"
                        onChange={(value: string) => { }}
                        value={expire ?? ''}
                        read_only={true}
                    />
                </div>
            </div>
            {showDocument && document &&
                <ViewDocument
                    studentId={studentId}
                    document={document}
                    onMinimizePreview={onMinimizePreview}
                    onDownloadFile={onDownloadFile}
                />
            }
        </div>
    )
}

export default PassportForm;